import {
  AdvanceOrderStatus,
  CustomerOrder,
  Order,
  OrderItemStatus,
  OrderStatus,
} from "~/application/types";

export const ORDER_STATUS_LABELS: Record<OrderStatus & OrderItemStatus.QUOTED, string> = {
  [OrderStatus.OPEN]: "Aberto",
  [OrderStatus.APPROVING]: "Em aprovação",
  [OrderItemStatus.QUOTED]: "Cotado",
  [OrderStatus.APPROVED]: "Aprovado",
  [OrderItemStatus.PARTIALLY_APPROVED]: "Aprovado parcialmente",
  [OrderStatus.WAITING]: "Aguardando aprovação",
  [OrderStatus.WAITING_APPROVAL]: "Aguardando aprovação",
  [OrderStatus.CANCELED]: "Cancelado",
  [OrderStatus.ON_APPROVAL]: "Em aprovação",
  [OrderStatus.CHANGING]: "Em alteração",
  [OrderStatus.REJECTED]: "Rejeitado",
  [OrderStatus.CANCELING]: "Em cancelamento",
  [OrderStatus.FAILED]: "Falha na emissão",
  [OrderStatus.QUOTING]: "Em cotação",
  [OrderStatus.EXPIRED]: "Expirado",
  [OrderStatus.ISSUED]: "Finalizado",
  [OrderStatus.PENDING_ISSUE]: "Emissão pendente",
  [OrderStatus.EXPIRED_TIME]: "Expirado",
  [OrderItemStatus.FAILED_CANCEL]: "Falha no cancelamento",
  [OrderItemStatus.DISAPPROVED]: "Rejeitado",
  [OrderStatus.WAITING_PAYMENT]: "Aguardando pagamento",
  [AdvanceOrderStatus.PAID]: "Finalizado",
  [OrderStatus.WAITING_FINANCIAL_APPROVAL]: "Aguardando aprovação financeira",
  [OrderStatus.FINISHED]: "Finalizado",
  [OrderStatus.ALL]: "Todos",
  [OrderItemStatus.DONE]: "Emitido",
};

export const ORDER_ITEM_STATUS_LABELS: Partial<Record<OrderItemStatus, string>> = {
  [OrderItemStatus.APPROVED]: "Aprovado",
  [OrderItemStatus.REJECTED]: "Reprovado",
  [OrderItemStatus.DISAPPROVED]: "Reprovado",
  [OrderItemStatus.PARTIALLY_APPROVED]: "Aprovado parcialmente",
  [OrderItemStatus.WAITING_FINANCIAL_APPROVAL]: "Aprovado parcialmente",
  [OrderItemStatus.APPROVING]: "Em aprovação",
  [OrderItemStatus.OPEN]: "Em aberto",
  [OrderItemStatus.FINISHED]: "Finalizado",
  [OrderItemStatus.DONE]: "Finalizado",
};

export const CART_ORDER_STATUS_LABELS: Record<OrderStatus & OrderItemStatus.QUOTED, string> = {
  [OrderStatus.OPEN]: "Aberto",
  [OrderItemStatus.QUOTED]: "Cotado",
  [OrderStatus.APPROVED]: "Aprovado",
  [OrderStatus.WAITING]: "Aguardando aprovação",
  [OrderStatus.CANCELED]: "Cancelado",
  [OrderStatus.ON_APPROVAL]: "Em aprovação",
  [OrderStatus.CHANGING]: "Em alteração",
  [OrderStatus.REJECTED]: "Rejeitado",
  [OrderStatus.CANCELING]: "Em cancelamento",
  [OrderStatus.QUOTING]: "Cotando",
  [OrderStatus.EXPIRED]: "Expirado",
  [OrderStatus.ISSUED]: "Finalizado",
  [OrderStatus.PENDING_ISSUE]: "Aprovado",
  [OrderStatus.EXPIRED_TIME]: "Expirado",
  [OrderStatus.WAITING_PAYMENT]: "Aguardando pagamento",
  [AdvanceOrderStatus.PAID]: "Adiantamento pago",
};

export enum OrderTab {
  ITEMS = "itens-do-pedido",
  MESSAGES = "mensagens",
  HISTORY = "historico",
  NOTIFICATIONS = "notificacoes",
}

export const ORDER_MENU_TABS = [
  { title: "Itens do Pedido", id: OrderTab.ITEMS },
  { title: "Notificações", id: OrderTab.NOTIFICATIONS },
  { title: "Histórico", id: OrderTab.HISTORY },
];

export enum OrderApprovalItem {
  ADVANCE = "advance",
  AIRWAY_ORDERS = "airwayOrders",
  ROOM_HOTEL_ORDERS = "roomHotelOrders",
  VEHICLE_ORDERS = "vehicleOrders",
  ROAD_ORDERS = "roadOrders",
}

export const getVoucherDownloadUrl = (order?: Order | CustomerOrder) => {
  if (!order || order.status !== OrderStatus.ISSUED) {
    return "";
  }

  return `${import.meta.env.VITE_API_URL}/orders/${order.uuid}/voucher`;
};
